export default __webpack_public_path__ + "static/media/42.2f8eee9e.jpg";